// Pure function: produces the HTML string injected into google.maps.InfoWindow.
// Themed (light|dark) and branded via primaryActionColor.

export const INFO_WINDOW_BTN_PREFIX = "gmap-detail-btn-"

const PALETTES = {
  light: {
    bg: "#ffffff",
    textPrimary: "#1a1a1a",
    textSecondary: "#888888",
    divider: "#eeeeee",
  },
  dark: {
    bg: "#1a1f2e",
    textPrimary: "#e8eaf0",
    textSecondary: "#7a8194",
    divider: "#252b3a",
  },
}

const getPalette = theme => PALETTES[theme] || PALETTES.light

const escapeHtml = str =>
  String(str).replace(
    /[&<>"']/g,
    ch => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch])
  )

export const renderInfoWindowContent = ({
  valueData = [],
  dataNames = [],
  marker = {},
  primaryActionColor = "#4f46e5",
  idValue = null,
  theme = "light",
}) => {
  const palette = getPalette(theme)

  const headerIdx = dataNames.findIndex(name => name && name.toLowerCase() !== "id")
  const headerLabel = headerIdx >= 0 ? dataNames[headerIdx] : ""
  const headerValue = headerIdx >= 0 ? marker[valueData[headerIdx]] : ""

  const rows = valueData
    .map((field, idx) => {
      if (idx === headerIdx) return ""
      if (dataNames[idx] && dataNames[idx].toLowerCase() === "id") return ""
      const value = marker[field]
      if (!value) return ""
      return `
        <div style="margin-bottom: 8px; font-size: 13px; line-height: 1.5;">
          <div style="
            font-size: 10px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            font-weight: 600;
            color: ${palette.textSecondary};
            margin-bottom: 2px;
          ">${escapeHtml(dataNames[idx])}</div>
          <div style="color: ${palette.textPrimary};">${escapeHtml(value)}</div>
        </div>`
    })
    .join("")

  const button = idValue
    ? `
      <div style="margin-top: 12px;">
        <button
          id="${INFO_WINDOW_BTN_PREFIX}${escapeHtml(idValue)}"
          style="
            display: block;
            width: 100%;
            padding: 8px 16px;
            background-color: ${primaryActionColor};
            color: #ffffff;
            border: none;
            border-radius: 6px;
            font-family: Roboto, 'Segoe UI', sans-serif;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            transition: filter 200ms ease;
          "
          onmouseenter="this.style.filter='brightness(0.9)'"
          onmouseleave="this.style.filter='brightness(1)'"
        >Voir le détail →</button>
      </div>`
    : ""

  return `
    <div style="
      font-family: Roboto, 'Segoe UI', sans-serif;
      min-width: 220px;
      background: ${palette.bg};
      border-radius: 12px;
      overflow: hidden;
    ">
      <div style="
        background: ${primaryActionColor};
        padding: 12px 16px;
        color: #ffffff;
      ">
        <div style="
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          font-weight: 600;
          opacity: 0.85;
          margin-bottom: 2px;
        ">${escapeHtml(headerLabel)}</div>
        <div style="font-size: 14px; font-weight: 700;">${escapeHtml(headerValue)}</div>
      </div>
      <div style="padding: 12px 16px;">
        ${rows}
        ${button}
      </div>
    </div>`
}
